import { TOUR_TRANSLATIONS } from "../translations"

export const getAssDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="assdetails-filters"]',
            title: t.assdetailsFilters.title,
            content: t.assdetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="assdetails-market-summary"]',
            title: t.assdetailsMarketSummary.title,
            content: t.assdetailsMarketSummary.content,
        },
        {
            target: '[data-tour="assdetails-retailer-summary"]',
            title: t.assdetailsRetailerSummary.title,
            content: t.assdetailsRetailerSummary.content,
        },
        {
            target: '[data-tour="assdetails-brand-summary"]',
            title: t.assdetailsBrandSummary.title,
            content: t.assdetailsBrandSummary.content,
        },
        {
            target: '[data-tour="assdetails-table"]',
            title: t.assdetailsTable.title,
            content: t.assdetailsTable.content,
        },
        {
            target: '[data-tour="assdetails-create-report"]',
            title: t.assdetailsCreateReport.title,
            content: t.assdetailsCreateReport.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.assdetailsEvolution.title,
            content: t.assdetailsEvolution.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'assdetails-table', closeOnLeave: true },
        },
        {
            target: '[data-tour="assdetails-not-listed"]',
            title: t.assdetailsNotListed.title,
            content: t.assdetailsNotListed.content,
            data: { triggerSelector: '[data-tour-show-all]' },
        },
        {
            target: '[data-tour="assdetails-footer"]',
            title: t.assdetailsFooter.title,
            content: t.assdetailsFooter.content,
        },
    ]
}
